<template>
  <div>
    <div class="panel_op">
      <el-button
        type="primary"
        size="small"
        @click="addInfo"
      >
        新增资讯
      </el-button>
    </div>
    <div class="panel_table">
      <el-table
        :data="tableData"
        :header-cell-style="headerCellStyle"
        @row-click="goDetail"
        v-loading="loading"
      >
        <el-table-column
          label="序号"
          type="index"
          width="100"
          :index="indexMethod"
        >
        </el-table-column>
        <el-table-column
          prop="title"
          label="标题"
        > </el-table-column>
        <el-table-column
          prop="createdAt"
          label="发布时间"
        > </el-table-column>
        <el-table-column
          label="状态"
          width="200px"
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                ['primary', 'success', 'danger' ][
                  scope.row.status
                ] || 'primary'
              "
              disable-transitions
            >{{ globalVar.INFO_STATUS_OPTIONS[scope.row.status].label }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          width="100px"
          label="操作"
        >
          <template slot-scope="scoped">
            <span
              v-if="scoped.row.status === globalVar.INFO_STATUS_PUBLISHED || scoped.row.status === globalVar.INFO_STATUS_FAILED"
              class="text_color_danger tw-cursor-pointer"
              @click.stop="deleteBefore(scoped.row, scoped.$index)"
            >删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="panel_pagination tw-flex tw-items-center tw-justify-center">
      <el-pagination
        hide-on-single-page
        background
        @current-change="getTableData"
        :current-page.sync="pagination.pageNum"
        :page-size="pagination.pageSize"
        layout="prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as api from '@/api'
export default {
  props: {
    // 栏目id
    id: String
  },
  data () {
    return {
      // 重新声明以便在template中直接使用
      // globalVar,
      // INFO_STATUS_OPTIONS: globalVar.INFO_STATUS_OPTIONS,
      // 页面loading
      // 过滤条件
      search: {
        status: '',
        keywords: ''
      },
      loading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }, // 分页对象
      tableData: []
    }
  },
  computed: {
    headerCellStyle () {
      return {
        backgroundColor: '#F7F8F9',
        color: '#909399',
        fontWeight: 'bold'
      }
    }
  },
  created () {
    // 获取某一栏目下的信息列表
    this.getTableData()
  },
  methods: {
    getTableData () {
      this.loading = true
      api
        .getInfoList(this.id, {
          ...this.pagination, ...this.search
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.pagination.pageNum = res.data.data.currentPage
            this.pagination.total = res.data.data.total
            this.tableData = res.data.data.list
            // console.log(this.tableData)
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          console.log(err)
          this.$message.error('请求出错')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 删除资讯
    deleteBefore (item, index) {
      this.$msgbox({
        title: '删除资讯',
        message: '确定要删除该资讯？',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.deleteInfo(item, index, instance, done)
          } else {
            done()
          }
        }
      })
    },

    // 删除
    deleteInfo (item, index, instance, done) {
      instance.confirmButtonLoading = true
      api
        .deleteInfo(item.id)
        .then((res) => {
          if (res.data.code === 0) {
            console.log('删除资讯成功', res.data.data)
            this.$message.success('删除成功！')
            this.tableData.splice(index, 1)
          } else {
            this.$message.error(res.data.message)
          }
          done()
        })
        .catch((err) => {
          console.log(err)
          this.$message.error('请求出错')
        })
        .finally(() => {
          instance.confirmButtonLoading = false
        })
    },
    // 跳转到新增资讯页面
    addInfo () {
      const path = '/info-manage/info-form/'
      this.jumpNew(path)
    },
    // 跳转到查看资讯详情页面
    goDetail (row) {
      const id = row.id ? row.id : ''
      // 前台只能查看
      const path = `/info-detail/${id}`
      this.jumpNew(path)
    },
    jumpNew (path) {
      const { href } = this.$router.resolve({
        path
      })
      window.open(href, '_blank')
    },

    indexMethod (index) {
      return (
        this.pagination.pageSize * (this.pagination.pageNum - 1) + index + 1
      )
    }
  }
}

</script>

<style lang="scss" scoped>
.panel {
  width: 100%;
  min-width: 1030px;
  min-height: 100%;
  padding: 0 30px;
  background: #ffffff;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  overflow: auto;
  &_header {
    padding: 20px 0;
  }
  &_op {
    padding: 10px 0;
  }
  &_table {
    padding: 10px 0;
  }
  &_pagination {
    margin: 20px 0;
    height: 40px;
  }
}
</style>
